import { ReactElement } from 'react'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/meta'
import PageBuilder from '@/components/layout/builder'
import Layout from '@/components/layout/layout'
import { mapPageStaticProps } from '@/utils/page-data'
import { getPromiseFromFetch } from '@/utils/request'
import { API, MOCK_DATA } from '@/constants'

import { WPPageData, WPRoutes } from '@/types'

const DEFAULT_REVALIDATE = 60 * 60 * 6
// const PRODUCT_REVALIDATE = 60 * 30
// const COLOR_REVALIDATE = 60 * 5
// const TAXONOMY_REVALIDATE = 60 * 30

// const SKIP_PRE_RENDER_PATHS = new Set([])
// const SKIP_PRE_RENDER_PREFIXES = []

const getRevalidateByType = () => {
  // if (_type === 'color' || _type === 'colore') return COLOR_REVALIDATE
  // if (_type === 'product') return PRODUCT_REVALIDATE
  // if (_type === 'taxonomy') return TAXONOMY_REVALIDATE
  return DEFAULT_REVALIDATE
}

const normalizePath = (segments: string[]) => {
  if (!segments.length) return '/'
  return `/${segments.join('/')}`.replace(/\/+/g, '/')
}

const shouldPreRenderPath = () => {
  // const path = normalizePath(segments)
  // if (SKIP_PRE_RENDER_PATHS.has(path)) return false
  // if (SKIP_PRE_RENDER_PREFIXES.some((prefix) => path.startsWith(prefix))) return false
  return true
}

export default function Page(pageProps: InferGetStaticPropsType<typeof getStaticProps>) {
  return <PageBuilder pageProps={pageProps} />
}

Page.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={pageProps} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({ params }: GetStaticPropsContext<{ routes: string[] }>) {
  const { data: pageProps, status } = MOCK_DATA
    ? { data: require(`@/data/pages/${params?.routes.join('/')}.json`), status: 200 }
    : ((await getPromiseFromFetch<WPPageData>({
        method: 'get',
        url: params?.routes.join('/')
      })) ?? {})

  // unknown URL: real 404 instead of a soft 404 (200 with empty page)
  // short revalidate so a transient CMS failure self-heals instead of caching a 404
  if (status !== 200) {
    return { notFound: true as const, revalidate: 300 }
  }

  const mapped = await mapPageStaticProps(pageProps)

  return {
    props: {
      ...mapped
    },
    revalidate: getRevalidateByType()
  }
}

export async function getStaticPaths() {
  const { data: routes } = MOCK_DATA
    ? { data: require('@/data/routes.json') as WPRoutes }
    : await getPromiseFromFetch<WPRoutes>({
        method: 'get',
        url: API.ROUTES
      })

  const uniquePathsMap = new Map<string, string[]>()

  routes.forEach((route) => {
    const segments = route.routes.filter((item) => item !== route.locale)
    const path = normalizePath(segments)

    if (!uniquePathsMap.has(path)) {
      uniquePathsMap.set(path, segments)
    }
  })

  const prioritizedPaths = [...uniquePathsMap.values()].filter(shouldPreRenderPath)

  return {
    paths: prioritizedPaths.map((segments) => ({
      params: { routes: segments }
      // locale: route.locale === defaultLocale ? '' : route.locale
    })),
    fallback: 'blocking'
  }
}
